import Client from './Client';

class ConsentHelper extends Client {
  constructor (params, form, options = {}) {
    super(options);
    this.params = params;
    this.isJquery = form instanceof jQuery || form && form.jquery;
    this.form = this.isJquery ? form[0] : form;
    this.emailInput = this.form.querySelector('input[type="email"]');
    this.submitButtonWrapper = this.form.querySelector('[type="submit"]').parentNode;
    return this.init().catch(error => {});
  }

  init () {
    return new Promise((resolve, reject) => {
      this.getConfig().then(() => {
        if (this.params.needsConsent) {
          if( this.params.isAllowSetCustomLocale && this.params.selectedLocale ) {
            this.config.locale = this.params.selectedLocale;
          }
          this.insertConsent(this.params.forceShowConsentMessaging);
        }
        resolve(this);
      }).catch(error => {
        if (this.params.needsConsent) {

          this.config = {
            "locale" : "",
            "localeRequiresMarketingCommunicationOptIn" : true
          };

          this.insertConsent();
        }
        reject(error);
      });
    });
  }

  buildConsentMarkup (requiresOptIn) {
    let isChecked = requiresOptIn ? '' : ' checked';
    let checkbox = `<input type="checkbox" id="${this.params.gdprId}" name="${this.params.gdprId}"${isChecked} />`;
    let optInClass = requiresOptIn ? ' gdpr-checkbox--optin' : '';
    let wrapperDiv = document.createElement("div");
    let label = (this.params.consentLabelEUCAN && requiresOptIn) 
      ? this.params.consentLabelEUCAN 
      : (!requiresOptIn)
        ? ''
        : this.params.consentLabel;

    wrapperDiv.className = `gdpr-checkbox${optInClass}`;
    wrapperDiv.innerHTML = `
    <div class="gdpr-privacy-policy">${this.params.privacyPolicy}</div>
      ${checkbox}
    <label>${label}</label>`;
    return wrapperDiv;
  }

  insertConsent (forceShowConsent = false) {
    let markup = this.buildConsentMarkup(forceShowConsent ? true : this.config.localeRequiresMarketingCommunicationOptIn);
    this.submitButtonWrapper.length ? this.submitButtonWrapper.parentNode.insertBefore(markup, this.submitButtonWrapper) : this.form.appendChild(markup);
  }

  consentData () {
    let consentValue = true;
    let checkbox = this.form.querySelector(`#${this.params.gdprId}`);
    let sourceData = this.params.source ? this.params.source : "WAC";
    let data = {
      "email": this.emailInput.value,
      "site": this.params.site,
      "source": sourceData,
      "action": "UPDATE_PREFERENCES",
      "locale": this.config.locale,
      "formUrl": window.location.href,
    };


    if (this.params.subscriptionKey) {
      if (this.params.subscriptionKey === 'soc2NDA') {
        data.site = "nda";
        data.consents = [
          {
            "key": this.params.subscriptionKey,
            "displayedText": document.getElementById('nda-text') != null ? document.getElementById('nda-text').innerText.replace(/"/g, '\\"') : "",
            "granted": true
          }
        ];
      } else {
        data.subscriptions = {};
        data.subscriptions[this.params.subscriptionKey] = true;
      }
      if (this.params.isEAP) {
        data.consents = [{
          "key": "eapTermsOfService",
          "displayedText": this.params.eapTermsOfService.replace(/"/g, '\\"'),
          "granted": true
        },
        {
          "key": "privacyPolicy",
          "displayedText": this.params.eapTermsOfService.replace(/"/g, '\\"'),
          "granted": true
        }];
      }
    }

    if (this.params.needsConsent) {
      if (checkbox) {
        consentValue = checkbox.checked;
      }
      data.consents = [
        {
          "key": this.params.consentKey,
          "displayedText": this.params.consentLabel.replace(/"/g, '\\"'),
          "granted": consentValue
        },
        {
          "key": "privacyPolicy",
          "displayedText": this.params.privacyPolicy.replace(/"/g, '\\"'),
          "granted": true
        }
      ];
      if (this.params.consentKey === 'allowPartnerShare') {
        data.consents.push({
          "key": "generalMarketingOptIn",
          "displayedText": this.params.consentLabel.replace(/"/g, '\\"'),
          "granted": consentValue
        });
      }
    }
    return data;
  }

  submitForm (onSuccess, onFail) {
    let consentData = this.consentData();
    const isConsentUpdate = this.params.isNotConsentUpdate ? !(this.params.isNotConsentUpdate == 'true') : true;
    let submitHandler = (this.params.subscriptionKey && isConsentUpdate && this.params.subscriptionKey !== "soc2NDA") ? this.postSubscriptions.bind(this) : this.postConsentUpdate.bind(this);
    if (this.isEAP) {
      submitHandler = this.postConsentUpdate.bind(this);
    }
    submitHandler(consentData).then(() => {
      onSuccess();
    }).catch(error => {
      onFail(error);
    });
  }
}

export default ConsentHelper;
